import { SignalQualityWithZero } from "../types"

// The formulas for the signal strengths are documented in:
// https://gitlab.com/satcube/cloud/requirements/-/issues/19

// TODO: Review these limits
const maxCN = 12.0
const minCN = -5.0

// TODO: Review these limits
const maxPD = -28.0
const minPD = -45.0

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

export function calcCNPercentage(cOverN: number): number {
  return Math.round(((clamp(cOverN, minCN, maxCN) - minCN) / (maxCN - minCN)) * 100)
}

export function calcPowerDetPercentage(signal: number): number {
  return Math.round(((clamp(signal, minPD, maxPD) - minPD) / (maxPD - minPD)) * 100)
}

export function signalQuality(cOverN: number): SignalQualityWithZero {
  const percentage = calcCNPercentage(cOverN)
  // Could probably do something like Math.round(percentage/25) here but
  // this doesn't yield the same type safety with SignalQualityWithZero.
  if (percentage == 0) {
    return 0
  }
  // C/N < 1.0 is a low strength
  if (percentage < 35) {
    return 1
  }
  // C/N < 2.0 is a medium strength
  if (percentage < 40) {
    return 2
  }
  // C/N < 6.0 is a high strength
  if (percentage < 65) {
    return 3
  }
  // Above 6.0 is very high
  return 4
}
